import React, { useState, useEffect } from 'react';

import { app } from '../context';
import { get, set } from '../localStorage';
import useNumInput from '../hooks/useNumInput';
import Form from './Form';
import Result from './Result';

import {
  APP_WIDTH,
  COLLECTS_PER_SECOND,
  UPGRADE_PRICE,
  UPGRADE_RATE,
  UPGRADE_BONUS,
  INIT_COLLECT,
  INIT_TARGET,
  INIT_WALKTIME,
} from '../constants';

const getCache = () =>
  get('input') || {
    collect: INIT_COLLECT,
    target: INIT_TARGET,
    walkTime: INIT_WALKTIME,
    doubled: false,
  };

export default () => {
  const [collect, onChangeCollect] = useNumInput(() => getCache().collect);
  const [target, onChangeTarget] = useNumInput(() => getCache().target);
  const [walkTime, onChangeWalkTime] = useNumInput(() => getCache().walkTime);
  const [doubled, setDoubled] = useState(() => getCache().doubled);
  const onChangeDoubled = e => setDoubled(e.target.checked);

  useEffect(() => {
    set('input', { collect, target, walkTime, doubled });
  }, [collect, target, walkTime, doubled]);

  return (
    <div className="my-3 mx-auto" style={{ width: APP_WIDTH }}>
      <app.Provider
        value={{
          collect,
          target,
          walkTime,
          doubled,
          onChangeCollect,
          onChangeTarget,
          onChangeWalkTime,
          onChangeDoubled,
          speed: collect * COLLECTS_PER_SECOND,
          price: UPGRADE_PRICE,
          bonus: UPGRADE_BONUS,
          upgradeRate: UPGRADE_RATE,
        }}
      >
        <Form />
        <br />
        <Result />
      </app.Provider>
    </div>
  );
};
